import { DASHBOARD_STATS, DASHBOARD_TEMPLATES } from "../../constants/apis";
import { getUrl } from "../../utilities/helpers";

export const fetchDashTemps =
  (query) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(DASHBOARD_TEMPLATES, query);
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const fetchTemplateStats =
  (query) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(DASHBOARD_STATS, query);
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };
